wbApp.controller('EmailTemplatesCtrl', ['$scope', '$translate', '$filter', '$timeout', '$modal', 'messageBoxSvc', 
    'emailTemplatesSvc', 'tenantInfo',
function ($scope, $translate, $filter, $timeout, $modal, messageBoxSvc, emailTemplatesSvc, tenantInfo) {
    
    $scope.emailTemplateId = null;
    $scope.oldEmailTemplateId = null;
    $scope.localeAlias = tenantInfo.languageAlias || 'cs';
    $scope.model = null;
    $scope.modelOrig = null;
    $scope.docIsClean = true;
    $scope.numberOfAttachments = 0;

    var codeEditorInstance;

    $scope.$on('refreshData', function (e, data) {
        $scope.onTemplateSelected();
        $scope.$broadcast('refreshEmailTemplateData', {});
    });

    $scope.onRefreshTemplate = function () {
        $scope.onTemplateSelected();
    }

    $scope.saveDisabled = function () {
        return $scope.docIsClean ||
               !$scope.model ||
               !$scope.emailTemplateId;
    }

    $scope.onSaveTemplate = function () {
        if (!$scope.saveDisabled()) {

            emailTemplatesSvc.update($scope.model).$promise.then(
                function (success) {

                    $scope.$broadcast('refreshEmailTemplateData', {});
                    loadData($scope.model.documentTemplateType, $scope.model.emailCategory);
                });
        }
    }

    $scope.onDeleteTemplate = function () {
        if (!!$scope.emailTemplateId && !!$scope.model) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_QUESTION',
                message: $translate.instant('TXT_CONFIRM_DELETE_EMAIL_TEMPLATE'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: function () {
                        emailTemplatesSvc.remove($scope.model.documentTemplateType, $scope.model.emailCategory, $scope.localeAlias).$promise.then(
                            function (success) {
                                $scope.$broadcast('refreshEmailTemplateData', {});
                                loadData($scope.model.documentTemplateType, $scope.model.emailCategory);
                            },
                            function (error) {
                                alert(error);
                            });
                    }
                }]
            });
        }
    }

    $scope.onValidateTemplate = function () {

        previewDialogPromise.$promise.then(function () {
            previewDialogPromise.$scope.detail = emailTemplatesSvc.preview($scope.model);
            previewDialogPromise.show();
        });
    }

    $scope.onAttachments = function () {
        attachmentsDialogPromise.$promise.then(function () {
            attachmentsDialogPromise.$scope.model = $scope.model;
            attachmentsDialogPromise.show();
        });
    }

    $scope.codemirrorLoaded = function (_editor) {
        codeEditorInstance = _editor.getDoc();
        $scope.docIsClean = codeEditorInstance.isClean();
        codeEditorInstance.on("change", function () {
            $scope.docIsClean = codeEditorInstance.isClean();
        });
    };

    $scope.editorOptions = {
        lineNumbers: true,        
        theme: 'default',
        mode: { name: "handlebars", base: "text/html" },
    };

    $scope.sampleDataEditorOptions = {
        lineNumbers: true,
        theme: 'default',
        mode: {
            name: "javascript",
            json: true,
            statementIndent: 2
        }
    };

    function loadData(documentTemplateType, emailCategory) {
        emailTemplatesSvc.getById(documentTemplateType, emailCategory, $scope.localeAlias).$promise.then(
            function (data) {
                $scope.model = data;
                $scope.modelOrig = angular.copy($scope.model);

                $scope.oldEmailTemplateId = $scope.emailTemplateId;

                if (!!codeEditorInstance) {
                    $timeout(function () {
                        codeEditorInstance.markClean();
                        $scope.docIsClean = codeEditorInstance.isClean();
                    })
                }
            }, function (err) {
                $scope.model = null;
                $scope.modelOrig = null;
            });
    }

    $scope.onTemplateSelected = function () {

        function loadWithIsCleanCheck(documentTemplateType, emailCategory) {
            if (!$scope.docIsClean) {
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_TITLE_QUESTION',
                    message: $translate.instant('TXT_CONFIRM_DISCARD_MODIFIED_DATA'),
                    buttons: [{
                        text: 'TXT_BTN_NO',
                        callback: function () {
                            $scope.emailTemplateId = $scope.oldemailTemplateId;
                        }
                    }, {
                        text: 'TXT_BTN_YES',
                        callback: function () {
                            loadData(documentTemplateType, emailCategory);
                        }
                    }]
                });
            } else {
                loadData(documentTemplateType, emailCategory);
            }
        }

        if (!!$scope.emailTemplateId) {
            var split = $scope.emailTemplateId.split('_');
            var documentTemplateType = parseInt(split[0]);
            var emailCategory = parseInt(split[1]);

            var info = emailTemplatesSvc.getInfoById(documentTemplateType, emailCategory, $scope.localeAlias);
            info.then(function (infoData) {
                
                $scope.numberOfAttachments = infoData.attachments.length;

                if (infoData.isCompatibleOverride || !infoData.isOverridden) {
                    loadWithIsCleanCheck(documentTemplateType, emailCategory);
                } else {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_ERROR',
                        message: $translate.instant('TXT_INCOMPATIBLE_TEMPLATE'),
                        buttons: [{
                            text: 'TXT_BTN_OK',
                            callback: function () {
                                loadWithIsCleanCheck(documentTemplateType, emailCategory);
                            }
                        }]
                    });
                }
            });
        }
    }

    var previewDialogPromise = $modal({
        templateUrl: 'messages/email-templates-preview-detail.html',
        show: false,
        scope: $scope.$new()
    });


    var attachmentsDialogPromise = $modal({
        templateUrl: 'messages/email-templates-attachments-detail.html',
        show: false,       
        scope: $scope.$new(),
    });

    attachmentsDialogPromise.$scope.$on('modal.hide.before', function () {
        $scope.$broadcast('refreshEmailTemplateData', {});
    })
}]);
